import React, { useEffect } from "react";
import { useRemoteComponent } from "@bookingcom/remote-component";
import useEvents from "../../hooks/useEvents";
import useUserAgent from "../../hooks/useUserAgent";
import Container from "../elements/Container";
import Frame from "../elements/Frame";

const AppleCardIndex = () => {
  const { grumble } = useEvents();
  const { isMobile } = useUserAgent();

  const { Component, error } = useRemoteComponent({
    project: "web-shell",
    service: "header-mfe",
    path: "/PromotionalBanner/Flights/Index",
    type: "capla"
  });

  useEffect(() => {
    if (error) {
      grumble("Remote component error: Apple card on Index page", { error });
    }
  }, [error, grumble]);

  return isMobile ? (
    <Frame attributes={{ style: { width: "100%" } }} p={4} mt={2} mb={2}>
      <Component />
    </Frame>
  ) : (
    <Container pt={6}>
      <Component />
    </Container>
  );
};

export default AppleCardIndex;
